enum ContentMode {
	STARTSCREEN = "STARTSCREEN",
	VIEWER = "VIEWER"
}

export default ContentMode;